export default "__VITE_ASSET__v9ljdCh7__"